import { VFlex } from '@/components/base';
import PluginFeedbackChart from '@/features/FrontPlugin/PluginFeedbackChart';
import PluginHeader from '@/features/FrontPlugin/PluginHeader';

function PluginHomePage() {
  return (
    <VFlex g={30}>
      <PluginHeader />
      <PluginFeedbackChart />
    </VFlex>
  );
}

export default PluginHomePage;
